import { render, staticRenderFns } from "./datetime-renderer.vue?vue&type=template&id=50915ba2&"
import script from "./datetime-renderer.vue?vue&type=script&lang=js&"
export * from "./datetime-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports